import { useCallback, useMemo } from "react";
import { Row, Col, Card } from "react-bootstrap";
import Availability from "./availability-tag/AvailabilityTag";
import OrchidProAvatar from "components/orchid-pro-avatar";
import AppointmentBook from "components/AppointmentBook/AppointmentBook";
import {
  getOrchidProCertificationString,
  getOrchidProTypeStringFromNewArr,
  getOrchidProNameAndAllGraduateDegreesString,
} from "utils/formatter/orchidPro";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";

function stripHtml(html) {
  let tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const AMPLITUDE_COMPONENT_NAME = "orchid-pro-card";

type Props = {
  orchidPro: OrchidPro;
  highlightToday: boolean;
  amplitudePageName: AmplitudePageName;
};

const OrchidProCard = ({
  orchidPro,
  highlightToday,
  amplitudePageName,
}: Props) => {
  const biography = useMemo(() => {
    return stripHtml(orchidPro.biography);
  }, [orchidPro.biography]);

  const trackLinkClick = useCallback(
    () =>
      track(amplitudePageName, AMPLITUDE_COMPONENT_NAME, "click", {
        eventProperties: {
          "orchid-pro-cognito-sub": orchidPro.cognito_sub,
        },
      }),
    [orchidPro.cognito_sub, amplitudePageName],
  );

  return (
    <Card className={styles["orchid-pro-card"]}>
      <Row>
        <Col md={7} xs={12} className={styles["orchid-pro-card__left"]}>
          <a
            href={`/professional-search/${orchidPro.custom_url}`}
            onClick={trackLinkClick}
          >
            <Row className={styles["orchid-pro-card__availability-tag"]}>
              {orchidPro.can_accept_payment && (
                <Availability
                  orchid_pro_cognito_sub={orchidPro.cognito_sub}
                  highlightToday={highlightToday}
                />
              )}
            </Row>
          </a>
          <Row className={styles["orchid-pro-card__rest"]}>
            <Col xs={12} md={3} className="p-0">
              <div className={styles["orchid-pro-card__info-avatar"]}>
                <OrchidProAvatar orchidPro={orchidPro} />
              </div>
              <a
                href={`/professional-search/${orchidPro.custom_url}`}
                onClick={trackLinkClick}
              >
                <div className={styles["orchid-pro-card__info-left"]}></div>
              </a>
            </Col>
            <Col xs={12} md={9} className="p-0">
              <a
                href={`/professional-search/${orchidPro.custom_url}`}
                onClick={trackLinkClick}
              >
                <div className={styles["orchid-pro-card__info-right"]}>
                  <h4 className="deep-blue rg-24">
                    {getOrchidProNameAndAllGraduateDegreesString(orchidPro)}
                  </h4>
                  {!orchidPro.orchid_pro_types
                    ?.length ? null : orchidPro.cognito_sub ===
                    "9929e6ac-8d68-4fba-8208-9b14ec05f132" ? (
                    <p className="rg-14 gray01 mb-0">
                      Licensed Occupational Therapist
                    </p>
                  ) : (
                    <p className="rg-14 gray01 mb-0">
                      {getOrchidProTypeStringFromNewArr(orchidPro)}
                    </p>
                  )}
                  {!orchidPro.orchid_pro_types?.length ? null : (
                    <p className="rg-12 darker">
                      {getOrchidProCertificationString(orchidPro)}
                    </p>
                  )}
                  <p className="fs-14 darker module line-clamp-5 mb-0">
                    {biography}
                  </p>
                </div>
              </a>
            </Col>
          </Row>
        </Col>
        <Col md={5} xs={12} className={styles["orchid-pro-card__right"]}>
          <AppointmentBook
            orchidPro={orchidPro}
            amplitudePageName={amplitudePageName}
            amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default OrchidProCard;
